/* eslint-disable max-nested-callbacks */
import store from './store';
import compareBar, * as barEvents from './comparisonbar';
import productGrid, {events as gridEvents} from './productgrid';
import * as modalEvents from './modalevents';

function isSmallScreen() {
    return window.matchMedia('screen and (max-width: 768px)').matches;
}

function getMaxProductCount() {
    const SMALL_SCREEN_MAX_PRODUCTS = 4;
    const LARGE_SCREEN_MAX_PRODUCTS = 5;
    return isSmallScreen() ? SMALL_SCREEN_MAX_PRODUCTS : LARGE_SCREEN_MAX_PRODUCTS;
}

export default function comparison() {
    const maxProductCount = getMaxProductCount();
    const minCompareCount = 2;
    const compareQueue = store();
    const initialProducts = compareQueue.getAll();
    const $compareBar = document.getElementById('compareBar');
    const $grid = document.getElementById('product-grid');
    const bar = compareBar($compareBar, initialProducts);
    const grid = productGrid($grid, initialProducts, maxProductCount);

    bar.on(barEvents.CLEAR, () => {
        compareQueue.clear();
        grid.deselectAll();
    });

    bar.on(barEvents.PRODUCT_REMOVED, product => {
        compareQueue.remove(product);
        grid.deselect(product);
        handleChange();
    });

    bar.on(barEvents.PRODUCT_COMPARE_REQUEST, () => {
        bar.disable();

        const ids = compareQueue.getAll().map(product => product.id);

        import('../../../comparisonchart/comparisonmodal.js').then(({ fetchProductCompareHTML, comparisonModal }) => {
            fetchProductCompareHTML(ids).then(html => {
                const modal = comparisonModal(html);

                modal.on(modalEvents.PRODUCT_REMOVED, product => {
                    bar.remove(product);
                    compareQueue.remove(product);
                    grid.deselect(product);
                    handleChange(true);
                });

                modal.on(modalEvents.MODAL_CLOSED, () => handleModalClose());
            });
        });
    });

    bar.on(barEvents.PRODUCT_ADDED, data => {
        if (isSmallScreen() || compareQueue.getAll().length <= 1) {
            return;
        }

        const $to = $compareBar.querySelector(`[data-id="${data.id}"] > img`);
        const $from = $grid.querySelector(`[data-productid="${data.id}"] > img`);

        if (!$to || !$from) {
            return;
        }

        const $fromClone = $from.cloneNode();
        const fromOffSet = $from.getBoundingClientRect();
        const toOffset = $to.getBoundingClientRect();

        $fromClone.style.transition = `all 300ms`;
        $fromClone.style.position = 'absolute';
        $fromClone.style.top = `${fromOffSet.top + document.documentElement.scrollTop}px`;
        $fromClone.style.left = `${fromOffSet.left + document.documentElement.scrollLeft}px`;
        $fromClone.style.height = `${fromOffSet.height}px`;
        $fromClone.style.width = `${fromOffSet.width}px`;
        $fromClone.style.zIndex = 9999;

        document.body.appendChild($fromClone);

        $fromClone.addEventListener('transitionend', function removeClone() {
            $fromClone.removeEventListener('transitionend', removeClone);
            $fromClone.parentElement.removeChild($fromClone);
        });

        $fromClone.style.top = `${toOffset.top + document.documentElement.scrollTop}px`;
        $fromClone.style.left = `${toOffset.left + document.documentElement.scrollLeft}px`;
        $fromClone.style.height = `${toOffset.height}px`;
        $fromClone.style.width = `${toOffset.width}px`;
    });

    grid.on(gridEvents.PRODUCT_SELECT, product => {
        compareQueue.add(product);
        bar.add(product);
        handleChange();
    });

    grid.on(gridEvents.PRODUCT_DESELECT, product => {
        compareQueue.remove(product);
        bar.remove(product);
        handleChange();
    });

    function handleModalClose() {
        const items = compareQueue.getAll();

        if (items.length >= minCompareCount) {
            bar.enable();
        } else {
            bar.disable();
        }
    }

    function handleChange(skipBarStateUpdate = false) {
        const items = compareQueue.getAll();

        if (items.length) {
            bar.show();

            if (!skipBarStateUpdate) {
                if (items.length >= minCompareCount) {
                    bar.enable();
                } else {
                    bar.disable();
                }
            }

            if (items.length >= maxProductCount) {
                grid.lock();
                return;
            }

            if (grid.isLocked()) {
                grid.unlock();
            }
        } else {
            bar.hide();
        }
    }
}
